import React, { FunctionComponent } from 'react'
import { useCheckoutSizes } from '../../utils/responsive'
import { useTranslation } from 'next-i18next'
import { Button } from '@afterpaytouch/core'

interface CtaButtonProps {
  lock: boolean
  submitted: boolean
}

export const CTAButton: FunctionComponent<CtaButtonProps> = ({ lock, submitted }) => {
  const isLocked = lock || submitted
  const { buttonSize } = useCheckoutSizes()
  const { t } = useTranslation()
  return (
    <Button loading={isLocked} type='submit' size={buttonSize} disabled={isLocked} testNameSpace={'passport-verify'} padding='Fluid'>
      {t('verifyIdentity:passport:cta')}
    </Button>
  )
}
